//
//

import { mapActions } from "vuex";
import { $http } from "@/assets/js/appFunc";
import AQCard from "@/components/Generics/AQCard";
import AQDropdown from "@/components/Generics/AQDropdown/AQDropdown.vue";
import chart from "./ProductivityChartWidget.vue";
import UsersList from "./UsersList.vue";

export default {
    components: {
        chart,
        UsersList,
        AQCard,
        AQDropdown
    },
    props: {
        currentGroup: {
            type: Object,
            default() {
                return {
                    id: "",
                    name: ""
                };
            }
        },
        dashboardType: {
            type: String,
            default: "user"
        }
    },
    data() {
        return {
            isActivated: true,
            cardOpen: false,
            showButtons: true,
            loading: true,
            chartActive: true,
            productivityInformation: {},
            resetSelectedData: false,
            optionsButton: [
                { label: this.$t("dashboard.year"), value: "year" },
                { label: this.$t("dashboard.month"), value: "months" },
                { label: this.$t("dashboard.week"), value: "weeks" }
            ],
            selectOptions: {
                weeks: [
                    {
                        label: this.$t("dashboard.charts.lastWeek"),
                        value: "ONE_WEEK"
                    },
                    {
                        label: this.$t("dashboard.charts.twoWeeksAgo"),
                        value: "TWO_WEEKS"
                    },
                    {
                        label: this.$t("dashboard.charts.threeWeeksAgo"),
                        value: "THREE_WEEKS"
                    }
                ],
                months: [
                    {
                        label: this.$t("dashboard.charts.lastMonth"),
                        value: "ONE_MONTH"
                    },
                    {
                        label: this.$t("dashboard.charts.twoMonthsAgo"),
                        value: "TWO_MONTHS"
                    },
                    {
                        label: this.$t("dashboard.charts.threeMonthsAgo"),
                        value: "THREE_MONTHS"
                    }
                ],
                year: [
                    {
                        label: this.$t("dashboard.charts.lastYear"),
                        value: "ONE_YEAR"
                    }
                ]
            },
            timeFramelabels: {
                weeks: [
                    this.$t("dashboard.charts.mondayShort"),
                    this.$t("dashboard.charts.tuesdayShort"),
                    this.$t("dashboard.charts.wednesdayShort"),
                    this.$t("dashboard.charts.thursdayShort"),
                    this.$t("dashboard.charts.fridayShort"),
                    this.$t("dashboard.charts.saturdayShort"),
                    this.$t("dashboard.charts.sundayShort")
                ],
                months: [
                    this.$t("dashboard.charts.week1"),
                    this.$t("dashboard.charts.week2"),
                    this.$t("dashboard.charts.week3"),
                    this.$t("dashboard.charts.week4"),
                    this.$t("dashboard.charts.week5"),
                    this.$t("dashboard.charts.week6")
                ],
                year: [
                    this.$t("dashboard.charts.januaryShort"),
                    this.$t("dashboard.charts.februaryShort"),
                    this.$t("dashboard.charts.marchShort"),
                    this.$t("dashboard.charts.aprilShort"),
                    this.$t("dashboard.charts.mayShort"),
                    this.$t("dashboard.charts.juneShort"),
                    this.$t("dashboard.charts.julyShort"),
                    this.$t("dashboard.charts.augustShort"),
                    this.$t("dashboard.charts.septemberShort"),
                    this.$t("dashboard.charts.octoberShort"),
                    this.$t("dashboard.charts.novemberShort"),
                    this.$t("dashboard.charts.decemberShort")
                ]
            },
            users: [],
            productivityData: [],
            chartModifiers: {
                primaryLine: 0,
                secondaryLine: null,
                timeFrame: "weeks",
                selectedRange: null
            }
        };
    },
    computed: {
        computedChartModifiers() {
            return { ...this.chartModifiers };
        }
    },
    watch: {
        computedChartModifiers: {
            handler(newValue, oldValue) {
                if (
                    newValue.timeFrame !== oldValue.timeFrame
                    && newValue.selectedRange !== null
                ) {
                    this.resetSelectedData = true;
                } else {
                    const compare = newValue.selectedRange && newValue.selectedRange.length ? newValue.selectedRange[0].value : "CURRENT";
                    this.fetchChartData(newValue.timeFrame, compare);
                    this.resetSelectedData = false;
                }
            },
            deep: true
        },

        currentGroup: {
            handler(newValue, oldValue) {
                if (newValue.id !== oldValue.id) {
                    this.chartModifiers = {
                        primaryLine: 0,
                        secondaryLine: null,
                        timeFrame: "weeks",
                        selectedRange: null
                    };
                    this.fetchGroupMembers();
                    this.fetchStatsProductivity();
                }
            }
        },
        dashboardType: {
            handler(newValue) {
                this.chartModifiers = {
                    primaryLine: 0,
                    secondaryLine: null,
                    timeFrame: "weeks",
                    selectedRange: null
                };
                if (newValue === "team") {
                    this.fetchGroupMembers();
                }
                this.fetchStatsProductivity();
            }
        }
    },
    created() {
        this.fetchStatsProductivity();
        if (this.dashboardType === "user") {
            this.fetchChartData(this.chartModifiers.timeFrame);
        } else {
            this.fetchGroupMembers();
        }
    },
    activated() {
        this.isActivated = true;
    },
    deactivated() {
        this.isActivated = false;
    },
    methods: {
        ...mapActions("dashboard", [
            "getProductivityData",
            "getTeamProductivityData",
            "getStatsProductivity"
        ]),

        setPrimary(index) {
            if (index === this.chartModifiers.secondaryLine) {
                this.setSecondary(null);
            }
            this.chartModifiers.primaryLine = index;
        },

        setSecondary(val) {
            if (val !== null) {
                // when selected a secondary value the time range comparison is cleared and disabled
                this.chartModifiers.selectedRange = null;
            }
            this.chartModifiers.secondaryLine = val;
        },

        toggleSecondary(index) {
            switch (index) {
                case this.chartModifiers.secondaryLine:
                    this.setSecondary(null);
                    break;
                case this.chartModifiers.primaryLine:
                    break;
                default:
                    this.setSecondary(index);
            }
        },
        fetchChartData(timeFrame, compare) {
            const { selectedRange } = this.chartModifiers;
            timeFrame = timeFrame || this.chartModifiers.timeFrame;
            compare = compare || (selectedRange && selectedRange.length ? selectedRange[0].value : "CURRENT");

            if (this.dashboardType === "user") {
                this.getProductivityData({ timeFrame, compare }).then(data => {
                    this.productivityData = data;
                });
            } else {
                if (this.users.length < 1) {
                    return;
                }
                const { id, type } = this.users[this.chartModifiers.primaryLine];
                const primary = { id, type };
                const payload = { timeFrame, compare, primary };
                if (this.chartModifiers.secondaryLine !== null) {
                    const { id: id1, type: type1 } = this.users[this.chartModifiers.secondaryLine];
                    payload.secondary = { id1, type1 };
                }
                if (id) {
                    this.getTeamProductivityData(payload).then(data => {
                        this.productivityData = data;
                    });
                }
            }
        },
        fetchStatsProductivity() {
            let payload = null;
            if (this.dashboardType === "team") {
                payload = this.currentGroup.id;
            }
            this.getStatsProductivity(payload).then(data => {
                this.productivityInformation = data;
                this.loading = false;
                if (this.productivityInformation.positivePercentage) {
                    this.productivityInformation.positivePercentage = Math.round(
                        this.productivityInformation.positivePercentage * 100
                    );
                }
            });
        },
        fetchGroupMembers() {
            if (this.dashboardType === "team" && this.currentGroup.id) {
                $http(
                    {
                        url: `/identity/tenants/one/level/users/group/${this.currentGroup.id}/false`,
                        type: "GET"
                    },
                    true
                )
                    .then(resp => {
                        const users = resp.data.map(
                            ({ firstName, lastName, id, status, email }) => ({
                                name: `${firstName} ${lastName}`.trim() || email,
                                id,
                                type: "user",
                                status
                            })
                        );
                        this.users = [
                            {
                                name: this.currentGroup.name,
                                id: this.currentGroup.id,
                                type: "group"
                            },
                            ...users
                        ];
                        this.fetchChartData(this.chartModifiers.timeFrame);
                    })
                    .catch(err => console.log(err));
            }
        }
    }
};
